import { createSlice } from "@reduxjs/toolkit";
import i18next from "i18next";

const initialState = {
  langData: localStorage.getItem('appLanguage') || 'en',
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.langData = action.payload;
      localStorage.setItem('appLanguage', action.payload);
      i18next.changeLanguage(action.payload);
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
